import { Button } from '@mantine/core';
import { ComponentProps, useMemo } from 'react';
import styles from './styles.module.css';
export type StandardButtonProps<C = 'button'> = ComponentProps<typeof Button<C>>;

export const StandardButton = (props: StandardButtonProps) => {
	const onClick = useMemo(
		() => (props.loading ? undefined : props.onClick),
		[props.loading, props.onClick]
	);
	return <Button w="100%" className={styles.root} variant="filled" {...props} onClick={onClick} />;
};
